import { Flame, Trophy, CalendarClock } from "lucide-react";

const BADGE_ICON = {
  "Year-Long Devotee": Trophy,
  "Half-Year Devotee": Trophy,
  "Quarterly Regular": Flame,
  "Two Months Strong": Flame,
  "Monthly Watcher": Flame,
  "On a Roll": Flame,
  "Just Started": CalendarClock,
};

export default function StreaksBanner({ streaks }) {
  if (!streaks || streaks.empty) return null;
  const Icon = BADGE_ICON[streaks.badge] || Flame;
  return (
    <div data-testid="streaks-banner" className="grid grid-cols-2 gap-px border border-white/15 bg-white/10 md:grid-cols-4">
      <Cell
        icon={<Flame className="h-4 w-4 text-[#FF3B30]" />}
        label="Current Streak"
        value={`${streaks.current_streak} ${streaks.current_streak === 1 ? "week" : "weeks"}`}
        accent
      />
      <Cell
        icon={<Trophy className="h-4 w-4 text-white" />}
        label="Longest Streak"
        value={`${streaks.longest_streak} ${streaks.longest_streak === 1 ? "week" : "weeks"}`}
      />
      <Cell
        icon={<CalendarClock className="h-4 w-4 text-white" />}
        label="Weeks Active"
        value={streaks.weeks_active}
      />
      <Cell
        icon={<Icon className="h-4 w-4 text-[#FF3B30]" />}
        label="Badge"
        value={streaks.badge}
        small
      />
    </div>
  );
}

function Cell({ icon, label, value, accent, small }) {
  return (
    <div className={`bg-neutral-950 p-5 ${accent ? "border-l-2 border-[#FF3B30]" : ""}`}>
      <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
        {icon}
        {label}
      </div>
      <p className={`mt-2 text-white ${small ? "font-display text-2xl uppercase" : "font-display text-4xl md:text-5xl"}`}>
        {value}
      </p>
    </div>
  );
}
